import { Box, DropdownTrigger, Group, LinkButton, TopBar } from '@salecycle/ui-component-library';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAccessLevel } from 'core/app/AppContext';
import { AppTopBarButtons } from './AppTopBarButtons';
import { usePreferencesDispatch, toggleSearchOverlay } from 'core/preferences/usePreferencesContext';
import useClientFromUrl from 'core/ui/utils/useClientFromUrl';
import useClient from 'core/ui/utils/useClient';
import styled from 'styled-components';
import { LanguagePicker } from '../LanguagePicker/LanguagePicker';

const Title = styled.span`
  font-weight: 600;
`;

const HELP_GUIDES_URL = 'https://salecycle.notion.site/MSC-Dashboards-12397195892a80c2b584f925b9878ed4';

export const AppTopBar: React.FC = () => {
  const { t } = useTranslation();
  const { accessLevel } = useAccessLevel();
  const dispatch = usePreferencesDispatch();

  const { clientIcon, clientColor } = useClientFromUrl();
  const client = useClient();

  const clientName =
    client.name && client.name !== ''
      ? client.name
      : t('search.allClients', {
          context: accessLevel === 'MultiSite' ? 'multisite' : null,
        });

  const shouldShowClientDropdown = accessLevel !== 'Site';

  return (
    <TopBar>
      <Group align="right" gap={30}>
        <Box>
          <LinkButton as="a" href={HELP_GUIDES_URL} target="_blank" rel="noopener noreferrer">
            <Title>{t('appTopBar.helpguides.label')}</Title>
          </LinkButton>
        </Box>
        <LanguagePicker />
        {shouldShowClientDropdown && (
          <Box>
            <DropdownTrigger
              label={clientName}
              ariaLabel={clientName}
              icon={clientIcon}
              iconBackground={clientColor}
              onClick={() => toggleSearchOverlay(dispatch, true)}
            />
          </Box>
        )}
        <AppTopBarButtons />
      </Group>
    </TopBar>
  );
};

export default AppTopBar;
